import { Button, Grid, InputLabel, OutlinedInput, Stack } from "@mui/material";
import AnimateButton from "../../../../Layout/components/@extended/AnimateButton";

const ReworkModal = (props) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <h4>Please give details as to why you're requesting more work done</h4>
      </Grid>
      <Grid item={12}>
        <Stack spacing={1}>
          <InputLabel>What needs to be done?</InputLabel>
          <OutlinedInput
            required
            id="reworkDesc"
            type="reworkDesc"
            onChange={(e) => props.setReworkDesc(e.target.value)}
            placeholder="Rework Description"
          />
        </Stack>
      </Grid>

      <Grid item xs={12}>
        <AnimateButton>
          <Button
            size="sm"
            type="button"
            variant="contained"
            color="primary"
            onClick={() => {
              props.submitReworkRequest();
              props.setReworkModal(false);
            }}
            sx={{ ml: 2, float: "right" }}
          >
            Confirm
          </Button>
          <Button
            size="sm"
            type="button"
            variant="outlined"
            color="primary"
            onClick={() => props.setReworkModal(false)}
            sx={{ ml: 2, float: "right" }}
          >
            Cancel
          </Button>
        </AnimateButton>
      </Grid>
    </Grid>
  );
};

export default ReworkModal;
